import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition =
	`${typeof baseRoute}/${number | ':reportTypeId'}/reportBlockFieldsForFilter${`?startDate=${string}&endDate=${string}` | ''}`;

export const ROUTE: RouteDefinition =
	`${baseRoute}/:reportTypeId/reportBlockFieldsForFilter`;

export const URL = (
	reportTypeId: number,
	startDate: string,
	endDate: string
): RouteDefinition =>
	`${baseRoute}/${reportTypeId}/reportBlockFieldsForFilter?startDate=${startDate}&endDate=${endDate}` as const;
